import React from "react";
import "./Progress.scss";
import {illustration, techStack} from "../../portfolio";
import {Fade} from "react-reveal";
import Skills from "../../assets/lottie/developer-skills.json";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

export default function StackProgress() {
  if (techStack.viewSkillBars) {
    return (
      <Fade bottom duration={1000} distance="20px">
        <div className="container-fluid">
        <div className="skills-container row">
          <div className="col-12 d-flex">
            <div className="skills-bar col-lg-6 col-md-6 col-12">
              <h1 className="skills-heading fw-bold">Proficiency</h1>
              {techStack.experience.map((exp, i) => {
                const progressStyle = {
                  width: exp.progressPercentage
                };
                return (
                  <div key={i} className="skill m-2">
                    <p classname="p-2">{exp.Stack}</p>
                    <div className="meter">
                      <span style={progressStyle}></span>
                    </div>
                  </div>
                );
              })}

             
            </div>
            <div className="skills-image col-lg-6 col-md-6 col-12">
                {illustration.animated ? (
                  <DisplayLottie animationData={Skills} />
                ) : (
                  <img
                    alt="Skills"
                    src={require("../../assets/images/skill.svg")}
                  />
                )}
              </div>
          </div>
        </div>
        </div>
      </Fade>
    );
  }
  return null;
}
